const ADMIN_AUDIENCE = 'ZeroTechAdmin';
const STOREFRONT_CLIENT = 'storefront';
const ADMIN_CLIENT = 'admin';

/** True when the JWT is a non-expired storefront customer token (not an admin dashboard token). */
export function isStorefrontToken(token: string | null | undefined): boolean {
  if (!token?.trim()) return false;

  try {
    const payload = decodeJwtPayload(token);
    if (!payload) return false;

    const clientApp = readString(payload, 'client_app');
    if (clientApp === ADMIN_CLIENT) return false;
    if (clientApp === STOREFRONT_CLIENT) return isTokenNotExpired(payload);

    const audience = readAudience(payload);
    if (audience === ADMIN_AUDIENCE) return false;

    if (payload['permissions'] != null) return false;

    return isTokenNotExpired(payload);
  } catch {
    return false;
  }
}

function isTokenNotExpired(payload: Record<string, unknown>): boolean {
  const exp = payload['exp'];
  if (typeof exp !== 'number' || !Number.isFinite(exp)) {
    return true;
  }
  const nowSeconds = Math.floor(Date.now() / 1000);
  return exp > nowSeconds + 30;
}

function decodeJwtPayload(token: string): Record<string, unknown> | null {
  const parts = token.split('.');
  if (parts.length < 2) return null;
  const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
  const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
  return JSON.parse(atob(padded)) as Record<string, unknown>;
}

function readAudience(payload: Record<string, unknown>): string | undefined {
  const aud = payload['aud'];
  if (typeof aud === 'string') return aud;
  if (Array.isArray(aud)) {
    const first = aud.find((item) => typeof item === 'string');
    return typeof first === 'string' ? first : undefined;
  }
  return undefined;
}

function readString(payload: Record<string, unknown>, key: string): string | undefined {
  const value = payload[key];
  return typeof value === 'string' ? value : undefined;
}
